module.exports = __webpack_public_path__ + "img/alberca.ad5ed02e.svg";